import {
    IonContent,
    IonPage,
    IonButton,
    useIonViewDidEnter,
} from '@ionic/react'
import React, { useState, useReducer } from 'react'
import { useHistory } from 'react-router'
import './index.css'
import {
    KnowledgeModel,
    KnowledgeSimilarModel,
} from '../../model/knowledge.model'
import editingKnowledgeReducer from './state/reducer'
import { EditingKnowledgePayload, ActionType } from './state/types'
import {
    updateKnowledge,
    UpdateKnowledgeRequest,
    AddKnowledgeRequest,
    addKnowledge,
    IdentityQuestionItem,
    getKnowledgeDetail,
} from '../../service/api/knowledge'
import { useSelector } from 'react-redux'
import { ReduxStore } from '../../redux/reducers'
import { UserModel } from '../../model/user.model'
import Toast, { ToastProps } from '../../components/Toast'
import Drawer from '../../components/Drawer'
import KQuestionSection from './components/KQuestionSection'
import KAnswersSection from './components/KAnswersSection'
import KSimilarQuestionSection from './components/KSimilarQuestionSection'
import Header from '../../components/Header'
let emptyFlagId = 0
// export const makeEmptyAnswer = (): KnowledgeAnswerModel => {
//     emptyFlagId++
//     return {
//         k_answer: '',
//         k_id: 0,
//         ka_id: 0,
//         flag_id: emptyFlagId,
//     }
// }
export const makeEmptySimilar = (
    k_question?: string
): KnowledgeSimilarModel => {
    emptyFlagId++
    return {
        k_id: 0,
        k_question: k_question || '',
        kq_id: 0,
        flag_id: emptyFlagId,
    }
}
export const makeEmptyKnowledge = (
    k_question?: string
): EditingKnowledgePayload => {
    return {
        k_title: k_question || '',
        k_id: 0,
        k_empty: !k_question,
        q_count: 0,
        KAnswers_has_empty: true,
        KQuestions: [
            {
                ...makeEmptySimilar(),
            },
        ],
        KAnswers: [],
    }
}

export type EditingDispathType = {
    dispatch: (action: ActionType) => void
}
export const EditingKnowledgeDispatch = React.createContext<EditingDispathType>(
    {
        dispatch: (action: ActionType) => undefined,
    }
)
const KnowledgeDetail: React.FC = () => {
    const history = useHistory<{
        knowledge?: KnowledgeModel // 传knowledge 表示更新知识点
        ktag_id?: number // 传 ktag_id，表示创建知识点
        question?: IdentityQuestionItem // 传 ktag_id 和 question 表示相似问说法学习创建知识点
    }>()
    const state = history.location.state || {}
    const userInfo = useSelector<ReduxStore, UserModel>(
        (store) => store.userInfo as UserModel
    )
    const [knowledge, dispatch] = useReducer(
        editingKnowledgeReducer,
        // 如果是相似问说法学习，则将待审核问题作为相似问
        makeEmptyKnowledge(state.question ? state.question.userQuestion : '')
    )
    const [knowledgeLoading, setKnowledgeLoading] = useState(!!state.knowledge)
    const [toastOptions, setToastToastOptions] = useState<ToastProps>({
        isOpen: false,
        message: '',
        color: 'error',
        duration: 1000,
    })
    const [drawerShow, setDrawerShow] = useState(false)
    useIonViewDidEnter(() => {
        if (state && state.knowledge) {
            queryKnowledgeDetail(state.knowledge)
        }
    })
    /** 查询知识点详情 */
    const queryKnowledgeDetail = async (knowledge: KnowledgeModel) => {
        try {
            setKnowledgeLoading(true)
            let res = await getKnowledgeDetail({
                kId: knowledge.k_id,
                appHash: userInfo.app_hash,
            })
            let resKnowledge = res.data.getKnowledge
            if (resKnowledge) {
                resKnowledge.KAnswers.length > 10 &&
                    (resKnowledge.KAnswers.length = 10)
                resKnowledge.KAnswers = resKnowledge.KAnswers.map((item) => ({
                    ...item,
                    finished: !!item.ka_id,
                    k_answer:
                        item.k_answer_type === 0
                            ? JSON.parse(item.k_answer).Content
                            : item.k_answer,
                }))
                resKnowledge.locked = knowledge.locked
                resKnowledge.isBotKnowledge = knowledge.isBotKnowledge
                dispatch({
                    type: 'setEditingKnowledge',
                    payload: resKnowledge,
                })
            }
        } catch (error) {}
        setKnowledgeLoading(false)
    }
    /** 添加知识点 */
    const queryAddKnowledge = async () => {
        if (!state.ktag_id) return
        try {
            if (knowledge.k_empty) {
                return
            }
            if (knowledge.KAnswers_has_empty) {
                return
            }
            let addData: AddKnowledgeRequest = {
                appHash: userInfo.app_hash,
                kUp: {
                    k_id: 0,
                    k_title: knowledge.k_title,
                    q_count: 0,
                    status: 1,
                    respond_all: 1,
                },
                aAdd: knowledge.KAnswers.map((item) => ({
                    k_answer:
                        item.k_answer_type === 0
                            ? JSON.stringify({
                                  Content: item.k_answer,
                              })
                            : item.k_answer,
                    k_answer_type: item.k_answer_type,
                    src_id: 1,
                    is_disable: 0,
                })),
                tagAdd: [
                    {
                        k_id: 0,
                        ktag_id: state.ktag_id,
                    },
                ],
                ...parseKSimilars(knowledge),
            }
            // 相似问说法学习使用
            if (state.question) {
                addData.KnowledgeEntityList = []
                addData.rqId = state.question.questionId
            }

            let res = await addKnowledge(addData)
            if (res.data.addKnowledge.data) {
                // 相似问说法学习使用
                if (state.question) {
                    history.go(-2)
                } else {
                    history.goBack()
                }
            } else {
                setToastToastOptions({
                    isOpen: true,
                    message: res.data.addKnowledge.error.detail,
                    color: 'error',
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
    /** 更新知识点 */
    const queryUpdateKnowledge = async () => {
        try {
            if (knowledge.k_empty) {
                return
            }
            if (knowledge.KAnswers_has_empty) {
                return
            }

            let updateData: UpdateKnowledgeRequest = {
                appHash: userInfo.app_hash,
                kId: knowledge.k_id,
                ...parseKAnswers(knowledge),
                ...parseKSimilars(knowledge),
            }
            // 更新知识点
            updateData.kUp = {
                k_id: knowledge.k_id,
                k_title: knowledge.k_title,
                status: knowledge.status,
                respond_all: 1,
                q_count: knowledge.q_count,
            }
            let res = await updateKnowledge(updateData)
            if (res.data.updateKnowledge.data) {
                history.goBack()
            } else {
                setToastToastOptions({
                    isOpen: true,
                    message: res.data.updateKnowledge.error.detail,
                    color: 'error',
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    /** 保存知识点 */
    const handleKnowledgeSave = () => {
        if (state && state.knowledge) {
            queryUpdateKnowledge()
            return
        }
        if (state && state.ktag_id) {
            queryAddKnowledge()
        }
    }
    const [showBtn, setShowBtn] = useState(true)
    const changeMenu = (type) => {
        setShowBtn(type)
    }
    console.log('drawerShow', showBtn, drawerShow)
    return (
        <IonPage className='knowledge-detail-page'>
            <IonContent className='content'>
                <Header title='知识详情' />
                {!knowledgeLoading && (
                    <EditingKnowledgeDispatch.Provider
                        value={{
                            dispatch: dispatch,
                        }}
                    >
                        <div
                            className='page-content-box'
                            style={{
                                bottom: showBtn || drawerShow ? '0' : '7.5rem',
                            }}
                        >
                            <KQuestionSection
                                value={knowledge.k_title}
                                disabled={
                                    knowledge.isBotKnowledge || knowledge.locked
                                }
                                similarDisable={!!knowledge.isBotKnowledge}
                                simiarShow={
                                    !knowledge.locked &&
                                    !knowledge.isBotKnowledge
                                }
                                statusShow={knowledge.isBotKnowledge}
                                status={knowledge.status}
                                onSimilar={() => setDrawerShow(true)}
                            />
                            <KAnswersSection
                                disabled={knowledge.locked}
                                answers={knowledge.KAnswers}
                                addDisabled={knowledge.KAnswers.length >= 10}
                                change={changeMenu}
                            />
                            <Drawer
                                isOpen={drawerShow}
                                onClose={() => setDrawerShow(false)}
                            >
                                {drawerShow && (
                                    <KSimilarQuestionSection
                                        similars={knowledge.KQuestions}
                                    />
                                )}
                            </Drawer>
                        </div>
                    </EditingKnowledgeDispatch.Provider>
                )}
                <Toast
                    {...toastOptions}
                    onClose={() =>
                        setToastToastOptions({ ...toastOptions, isOpen: false })
                    }
                />
                {!knowledgeLoading && !showBtn && !drawerShow ? (
                    <div className='footer'>
                        <IonButton
                            disabled={
                                knowledge.k_empty ||
                                knowledge.KAnswers_has_empty
                            }
                            className='save-button'
                            onClick={handleKnowledgeSave}
                        >
                            保存
                        </IonButton>
                    </div>
                ) : null}
            </IonContent>
        </IonPage>
    )
}
/** 转换默认答案数据，用以发送请求 */
const parseKAnswers = (knowledge: EditingKnowledgePayload) => {
    const aUp = knowledge.KAnswers.filter(
        (item) => item.update && item.k_id && item.k_answer.trim()
    ).map((item) => ({
        k_id: item.k_id,
        k_answer:
            item.k_answer_type === 0
                ? JSON.stringify({
                      Content: item.k_answer.trim(),
                  })
                : item.k_answer,
        k_answer_type: item.k_answer_type,
        ka_id: item.ka_id,
    }))
    // 删除知识点答案
    const aDel = knowledge.KAnswers_to_delete || []
    // 添加知识点答案
    const aAdd = knowledge.KAnswers.filter(
        (item) => !item.ka_id && item.k_answer.trim()
    ).map((item) => ({
        k_answer:
            item.k_answer_type === 0
                ? JSON.stringify({
                      Content: item.k_answer.trim(),
                  })
                : item.k_answer,
        k_answer_type: item.k_answer_type,
        k_id: knowledge.k_id,
    }))
    const answerData = {
        aUp,
        aDel,
        aAdd,
    }
    return answerData
}
/** 转换相似问数据，用以发送请求 */
const parseKSimilars = (knowledge: EditingKnowledgePayload) => {
    const qUp = knowledge.KQuestions.filter(
        (item) => item.update && item.kq_id && item.k_question.trim()
    ).map((item) => ({
        k_question: item.k_question.trim(),
        kq_id: item.kq_id,
    }))
    const qDel = knowledge.KQuestions_to_delete || []
    const qAdd = knowledge.KQuestions.filter(
        (item) => !item.kq_id && item.k_question.trim()
    ).map((item) => ({
        k_question: item.k_question.trim(),
        k_id: knowledge.k_id,
    }))
    return {
        qUp,
        qDel,
        qAdd,
    }
}
export default KnowledgeDetail
